// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"6af0b757","300":"ad8028fa","461":"a123b9b0","496":"4c184f8a","557":"fbc3b2c1","810":"b20503e6","831":"093e80ca","852":"9d3bb736","915":"d20731a0","952":"529b5be7","972":"112fa4c1"}[chunkId] + ".chunk.js";
};